import React, { memo } from "react";

const PriceConversion = memo((props) => {
    let totalPrice = props && props.price ? props.price : "";
    if (totalPrice !== "") {
      let checkDigit = totalPrice.toString().split(".");
      let ret = "";
      let i = 0;
      if (totalPrice.toString().indexOf(".") == -1) {
        totalPrice = totalPrice;
      } else {
        if (checkDigit == "00") {
          totalPrice = checkDigit.trim();
        } else {
          if (checkDigit.length === 2) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              if (i >= checkDigit[1].length) ret += "0";
              else ret += checkDigit[1][i];
            }
          } else if (checkDigit.length === 1) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              ret += "0";
            }
          }
          ret = ret.toString();
          totalPrice = ret;
        }
      }
    }
    return props.symbol+totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
 
})
export default PriceConversion;